import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/GreenHydrogenElectrolyzerHero-bg.webp";
import ArticleImg        from "../../asset/images/news/news-3.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ghe { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .ghe-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
   
  }
  .ghe-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right;
    display: block;
  }
  .ghe-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .ghe-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ghe-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px;
    max-width: 520px;
  }
  .ghe-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .ghe-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .ghe-breadcrumb {
    width: 100%; padding: 40px 0 0 0;
  }
  .ghe-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto;
    padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .ghe-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none;
    display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .ghe-bc-item:hover { color: #EB2019; }
  .ghe-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .ghe-bc-sep img { width: 24px; height: 24px; display: block; }
  .ghe-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER WRAPPER ══ */
  .ghe-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
  }

  /* ══ MAIN SECTION ══ */
  .ghe-main-section { padding: 80px 0 120px 0; }
  .ghe-main-row {
    display: flex; align-items: flex-start; gap: 89px;
  }

  /* ══ ARTICLE ══ */
  .ghe-article { flex: 1; min-width: 0; }

  /* Meta bar */
  .ghe-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .ghe-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A;
    padding-right: 15px;
  }
  .ghe-meta-item:last-child {
    border-right: none;
    padding-right: 0;
  }
  .ghe-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  /* Article title */
  .ghe-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  /* Article image */
  .ghe-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  /* Body text */
  .ghe-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ghe-article-body p {
    margin-bottom: 15px;
  }
  .ghe-article-body p:last-child { margin-bottom: 0; }

  /* Bold paragraph headings */
  .ghe-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%;
    display: block;
  }

  .ghe-article-body strong { font-weight: 600; color: #202020; }

  .ghe-red-link {
    color: #EB2019; text-decoration: underline;
  }
  .ghe-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .ghe-bottom-row {
    display: flex; align-items: center;
    justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7;
    flex-wrap: wrap; gap: 16px;
  }
  .ghe-bottom-nav {
    display: flex; align-items: center; gap: 30px;
  }
  .ghe-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .ghe-nav-btn:hover { color: #EB2019; }
  .ghe-nav-btn img { width: 40px; height: 40px; display: block; }

  .ghe-share-icons {
    display: flex; align-items: center; gap: 20px;
  }
  .ghe-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0;
    transition: opacity 0.15s;
  }
  .ghe-share-icon:hover { opacity: 0.85; }
  .ghe-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .ghe-sidebar { flex: 0 0 475px; }

  .ghe-sidebar-block { margin-bottom: 60px; }

  .ghe-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }

  /* Recent posts */
  .ghe-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .ghe-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .ghe-recent-item:hover .ghe-recent-title { color: #EB2019; }
  .ghe-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .ghe-recent-body { flex: 1; min-width: 0; }
  .ghe-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }

  /* Social icons */
  .ghe-social-icons { display: flex; align-items: center; gap: 30px; }
  .ghe-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .ghe-social-icon:hover { opacity: 0.8; }
  .ghe-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ghe-hero             { height: 350px; }
    .ghe-hero-content     { padding: 0 32px; }
    .ghe-hero-title       { font-size: 30px; }
    .ghe-hero-divider     { width: 100%; max-width: 479px; }
    .ghe-breadcrumb       { padding: 24px 0 0 0; }
    .ghe-breadcrumb-inner { padding: 0 32px; }
    .ghe-inner            { padding: 0 32px; }
    .ghe-main-section     { padding: 48px 0 60px 0; }
    .ghe-main-row         { flex-direction: column; gap: 48px; }
    .ghe-sidebar          { flex: none; width: 100%; }
    .ghe-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ghe-hero             { height: 360px; }
    .ghe-hero-content     { padding: 0 16px; }
    .ghe-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .ghe-hero-divider     { width: 100%; }
    .ghe-hero-subtitle    { font-size: 14px; }
    .ghe-breadcrumb       { padding: 30px 0 0 0; }
    .ghe-breadcrumb-inner { padding: 0 16px; }
    .ghe-bc-item          { font-size: 14px; gap: 14px; }
    .ghe-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ghe-bc-sep img       { width: 22px; height: 22px; }
    .ghe-inner            { padding: 0 16px; }
    .ghe-main-section     { padding: 30px 0 60px 0; }
    .ghe-main-row         { flex-direction: column; gap: 60px; }
    .ghe-sidebar          { flex: none; width: 100%; }
    .ghe-sidebar-title { font-size: 20px;}
    .ghe-article-title    { font-size: 20px; margin-bottom: 15px; }
    .ghe-article-body     { font-size: 14px; }
    .ghe-meta-item        { font-size: 14px; }
    .ghe-article-img      { margin: 25px 0 30px 0; height: 250px; }
    .ghe-h2               { font-size: 16px; margin: 15px 0 15px 0; }
    .ghe-nav-btn img      { width: 24px; height: 24px; }
    .ghe-nav-btn          { font-size: 14px; }
    .ghe-share-icon img   { width: 34px; height: 34px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-guide/",
  },
];


export default function GreenHydrogenElectrolyzer() {
  return (
    <div className="ghe">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="ghe-hero">
        <img className="ghe-hero-bg" src={HeroBgImg} alt="Green Hydrogen Hero" />
        <div className="ghe-hero-overlay" />
        <div className="ghe-hero-content">
          <h1 className="ghe-hero-title">
            Green Hydrogen Power Electronics: Ador Powertron At The Forefront Of Electrolyzer Rectifier Setups
          </h1>
          <hr className="ghe-hero-divider" />
          <p className="ghe-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="ghe-breadcrumb" aria-label="Breadcrumb">
        <div className="ghe-breadcrumb-inner">
          <a href="/" className="ghe-bc-item">Home</a>
          <span className="ghe-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="ghe-bc-item">News &amp; Updates</a>
          <span className="ghe-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ghe-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="ghe-main-section">
        <div className="ghe-inner">
          <div className="ghe-main-row">

            {/* ── ARTICLE ── */}
            <article className="ghe-article">

              {/* Meta bar */}
              <div className="ghe-meta-bar">
                <span className="ghe-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="ghe-meta-item"><img src={CalendarIcon} alt="date" /> July 17, 2025</span>
                <span className="ghe-meta-item"><img src={ClockIconImg} alt="time" /> 5:55 am</span>
                <span className="ghe-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="ghe-article-title">
                Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups
              </h1>

              {/* Body */}
              <div className="ghe-article-body">

                <p><strong>Have you heard the buzz around green hydrogen lately?</strong></p>

                <p>It's not simply a movement — it's the fortune of clean power. But while the idea of separating water into hydrogen and oxygen may sound sexy, making it occur at an industrial scale is anything but.</p>

                <p>So, what's the actual tale after green hydrogen, and why does <strong>Ador Powertron</strong> have a front-row seat to this trajectory?</p>

                <p>Let's understand and dive in.</p>

                {/* Article image */}
                <img className="ghe-article-img" src={ArticleImg} alt="Green Hydrogen Electrolyzer" />

                <span className="ghe-h2">First things first: What is green hydrogen?</span>

                <p>In simple terms, <strong>green hydrogen</strong> is hydrogen produced using renewable electricity (think solar, wind, or hydro). Unlike grey or blue hydrogen, it's entirely clean — no carbon emissions involved.</p>

                <p><strong>By 2030</strong>, the world is aiming big:</p>

                <p><strong>420 GW</strong> of global electrolyzer capacity</p>

                <p><strong>150 million tons</strong> of hydrogen produced annually (IEA, 2024)<br />
                And right here in India, we're setting the bar with a target of <strong>5 million tons</strong> of green hydrogen production.</p>

                <span className="ghe-h2">But here's the catch:</span>

                <p>You can't simply plug in an electrolyzer and expect it to work by magic.<br />
                You need <strong>reliable, efficient, and precise power electronics</strong> behind it — and that's where the real innovation kicks in.</p>

                <p>The challenge lies in the fact that creating green hydrogen involves more than just using the newest electrolyzers available. That's where <strong>hydrogen electrolyzer power electronics</strong> and <strong>industrial hydrogen rectifier systems</strong> dive in. These technologies are responsible for splitting water into hydrogen and oxygen by electrolysis, which converts grid-supplied AC electricity into clean DC power.</p>

                <p>Electrolyzers face the risk of voltage fluctuation, downtime, and shorter lifespans without reliable and efficient rectifiers. Thus, having the proper electronics is more important than ever, as India aims to produce 5 million tons of green hydrogen by 2030 (Ministry of New and Renewable Energy, India).</p>

                <p>In this blog, we will discuss electrolyzer rectifier setups and their importance in terms of performance, cost efficiency, and sustainability.</p>

                <p>Let's dive in!</p>

                <span className="ghe-h2">Let's start with precision power control for hydrogen electrolyzers</span>

                <p>The production of green hydrogen is based on precise power regulation. For hydrogen electrolyzers to operate correctly and produce the most hydrogen possible, a constant, carefully regulated DC voltage and current are required. Thus, cutting-edge technologies such as digital controls and real-time monitoring are incorporated into contemporary hydrogen electrolyzer power electronics.</p>

                <span className="ghe-h2">Now, let's see how these systems are adaptable across different electrolyzer technologies.</span>

                <p>One benefit of electrolyzer rectifier setups is their adaptability to various types of electrolyzers, including alkaline and PEM (Proton Exchange Membrane) types. Industries can future-proof their hydrogen infrastructure due to its sturdy construction, which can handle a range of input and output needs.</p>

                <span className="ghe-h2">Another important aspect? Built for Indian industrial environments.</span>

                <p>Operating in diverse Indian industrial conditions demands reliability and durability. <strong>Ador Powertron's</strong> rectifier systems are engineered to withstand high ambient temperatures, dust, and fluctuating grid conditions common in Indian industrial environments.<br />
                This dedication to local adaptation strengthens Ador's standing as a reliable supplier of <strong>industrial hydrogen rectifier systems</strong> in India.</p>

                <span className="ghe-h2">Let's not overlook energy efficiency, which is critical to a cost-effective exhibit of sustainable hydrogen.</span>

                <p>In addition to constant arrangement, energy efficiency plays a vital role in reducing the total cost of producing green hydrogen. Current semiconductors and design strategies are used to decrease heat production and power losses. Green hydrogen is more economically competitive because it needs less energy, resulting in a lower cost per kilogram of hydrogen produced.</p>

                <span className="ghe-h2">Ultimately, let's discuss the importance of end-to-end expertise and support.</span>

                <p>Advanced industrial hydrogen rectifier systems require continuous support in addition to excellent design. As production increases, professional assistance ensures that electrolyzer installations remain economical, safe, and efficient, from installation to maintenance and technical training.</p>

                <span className="ghe-h2">In a Nutshell</span>

                <p>India is taking the initiative with strong green hydrogen goals as the global transition to sustainable energy gains speed. Furthermore, having appropriate technology is just as crucial as having huge ambitions on paper. Organizations like <strong>Ador Powertron</strong> can help with that.</p>

                <p>With their decades of experience in industrial power electronics, they are helping companies move beyond small-scale trials and scale up production.</p>

                <p><strong>Ador Powertron</strong> 's hydrogen electrolyzer power electronics and <strong>industrial hydrogen rectifier systems</strong> in India contribute to the conversion of renewable energy into actual, usable hydrogen by providing electrolyzers with dependable and efficient DC power.</p>

                <p>Explore Ador's comprehensive solutions and discover how they can power your journey towards green hydrogen production. Contact us now!</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="ghe-bottom-row">
                <div className="ghe-bottom-nav">
                  <a href="/news/transformer-bushings-guide/" className="ghe-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/" className="ghe-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="ghe-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/" className="ghe-share-icon" target="blank" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fgreen-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups%2F&mode=login" className="ghe-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fgreen-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups%2F%26title%3DGreen%2520Hydrogen%2520Power%2520Electronics%2520by%2520Ador%2520Powertron%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fgreen-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups%2F" className="ghe-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="ghe-sidebar">

              {/* Recent Posts */}
              <div className="ghe-sidebar-block">
                <p className="ghe-sidebar-title">Recent Posts</p>
                <div className="ghe-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="ghe-recent-item">
                      <img src={post.img} alt={post.title} className="ghe-recent-img" />
                      <div className="ghe-recent-body">
                        <span className="ghe-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="ghe-sidebar-block">
                <p className="ghe-sidebar-title">Social Media</p>
                <div className="ghe-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="ghe-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ghe-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}